import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {MsgBoxService} from '../../shared/msg-box.service';
import {I18NService} from '../../i18n/i18n.service';
import {errorCode} from '../../commons/commons';
import {ErrorCode} from '../../api/errors';
import {UsersService} from '../../shared/users.service';
import {Observable, Subject} from 'rxjs';
import {AdminCapabilities, UserFilter} from 'auth-commons';
import {map, takeUntil} from 'rxjs/operators';
import {can} from '../../shared/permissions';
import {Permission} from 'smag-commons/dto/api';
import {APP_CONFIG_TOKEN, AppConfig} from '../../app.config';
import {DEFAULT_ORDER} from '../perm-admin/users-permission-assignments/users-permission-assignments.component';


@Component({
    selector: 'app-user-admin-panel',
    templateUrl: './user-admin-panel.component.html',
    styleUrls: ['./user-admin-panel.component.scss']
})
export class UserAdminPanelComponent implements OnInit, OnDestroy {

    private destroyed = new Subject<void>();

    adminCapabilities: Observable<AdminCapabilities>;
    userFilter: UserFilter;

    constructor(@Inject(APP_CONFIG_TOKEN) private readonly cfg: AppConfig,
                private readonly i18n: I18NService,
                private readonly router: Router,
                private readonly usersService: UsersService,
                private readonly msgBoxService: MsgBoxService) {
        this.adminCapabilities = null;
        this.userFilter = {
            username: null,
            firstName: null,
            lastName: null,
            enabled: null,
            missingChecks: [],
            missingChecksOr: [],
            enabled2FA: null,
            mandatory2FA: null,
            passwordValid: null,
            orderBy: [DEFAULT_ORDER]
        };
    }

    ngOnInit() {
        this.adminCapabilities = this.usersService.permissions.pipe(
            map(usersPerms => ({
                canCreate: can(usersPerms, Permission.CREATE),
                canRead: can(usersPerms, Permission.READ),
                canUpdate: can(usersPerms, Permission.UPDATE),
                canDelete: can(usersPerms, Permission.DELETE)
            } as AdminCapabilities)),
            takeUntil(this.destroyed)
        );
    }

    ngOnDestroy() {
        this.destroyed.next();
        this.destroyed.complete();
    }

    canAdmin(adminCaps: AdminCapabilities): boolean {
        return adminCaps.canCreate || adminCaps.canRead || adminCaps.canUpdate || adminCaps.canDelete;
    }

    onInfoOccurred(event: string) {
        this.msgBoxService.info(event);
    }

    onErrorOccurred(event: [string, Error]) {
        const msg = mkErrorMessage(event[1]) || event[0];
        this.msgBoxService.error(this.i18n.translate(msg), event[1]);
    }
}

function mkErrorMessage(err: Error): string {
    const code = errorCode(err);
    switch (code) {
        case ErrorCode.USERNAME_ALREADY_EXIST:
            return 'Email address already exists';
        case ErrorCode.EMAIL_ALREADY_EXIST:
            return 'Email address already exists';
        case ErrorCode.MOBILE_NUMBER_ALREADY_EXIST:
            return 'Mobile number already exists';
        case ErrorCode.FORBIDDEN_WORDS:
            return 'Password contains words like name, surname, username or email';
        case ErrorCode.PASSWORD_NOT_STRONG:
            return 'Password is not strong enough';
        default:
            return null; // fall-back on message in auth-commons
    }
}
